export function useQueryParams() {
  return window.location.search
    .replace('?', '')
    .split('&')
    .reduce((accumulator, param) => {
      const [key, value] = param.split('=', 2);

      accumulator[key] = decodeURIComponent(value);

      return accumulator;
    }, {} as { [key: string]: string });
}
